"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BannerActions_vue_1 = __importDefault(require("./BannerActions.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const CropIndicator_vue_1 = __importDefault(require("./CropIndicator.vue"));
const Crop_1 = __importDefault(require("@becrop/components/TrialsSummary/Abstract/models/Crop"));
const ComparisonToggler_vue_1 = __importDefault(require("@becrop/components/Results/Projects/ComparisonToggler.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
let BannerHeader = class BannerHeader extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isReducePanel = false;
    }
    get cropsInvolved() {
        const numLocations = this.summaryConfigData.configuration.locations.length;
        const crops = this.summaryConfigData.configuration.locations.map((l) => l.crop);
        const cropsUnique = [...new Set(crops)].join('|');
        return cropsUnique;
    }
    get curatedCrop() {
        const crops = this.cropsInvolved;
        return (this.isVS) ? new Crop_1.default({ name: crops, logo: '', color: '', image: '' }) : this.summaryData.crop[0];
    }
    reducePanel() {
        this.isReducePanel = true;
    }
    expandedPanel() {
        this.isReducePanel = false;
    }
    toggleComparison() {
        this.$emit('toggleComparison');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], BannerHeader.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], BannerHeader.prototype, "isComparisonAvailable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], BannerHeader.prototype, "isVS", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BannerHeader.prototype, "summaryData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BannerHeader.prototype, "summaryConfigData", void 0);
BannerHeader = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BannerActions: BannerActions_vue_1.default,
            Tag: bmk_ui_framework_1.Tag,
            CropIndicator: CropIndicator_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            ArrowUp: lucide_vue_next_1.ArrowUp,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            ComparisonToggler: ComparisonToggler_vue_1.default
        },
    })
], BannerHeader);
exports.default = BannerHeader;
